import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { mapGraphQLErrors } from 'providers/tanstack-query/utils'
import { Schema } from '../../form/schema'
import { toDTO } from './api/mapper'
import { UPDATE_DATA_SAMPLING } from './api/mutation'
import { Data, Variables } from './api/types'
import { Props, UseUpdateDataSampling } from './types'

export const useUpdateDataSampling = ({ workspaceId }: Props): UseUpdateDataSampling => {
  const { t } = useTranslation('features/performance', {
    keyPrefix: 'prebidStack.dataSampling.update',
  })
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const { isPending: loading, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_DATA_SAMPLING,
    onCompleted: async (data: Data) => {
      const {
        updateWorkspace: { errors },
      } = data
      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('error'), { variant: 'error' })
      } else {
        setErrors({})
        enqueueSnackbar(t('success'), { variant: 'success' })
      }
    },
  })

  const update = async (data: Schema): Promise<void> => {
    await mutateAsync({
      input: toDTO(data, workspaceId),
    })
  }

  return { errors, loading, update }
}
